import { useCallback, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { AppShell } from "../components/AppShell";
import { AiRunner } from "../components/ai/AiRunner";
import { AiHistory } from "../components/ai/AiHistory";
import { isAdmin, useAuth } from "../context/AuthContext";

export default function AiPage() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const [reloadKey, setReloadKey] = useState(0);
  const onFinished = useCallback(() => setReloadKey((k) => k + 1), []);
  if (!isAdmin(user)) return <Navigate to="/" replace />;
  return (
    <AppShell>
      <section className="tr-fade-up space-y-1">
        <div className="tr-eyebrow">Inteligencia artificial</div>
        <h1 className="text-2xl font-extrabold tracking-tight text-[#182235] sm:text-3xl" data-testid="ai-page-title">Clasificar con IA</h1>
        <p className="text-sm text-[#5b667a]">La IA lee los archivos de Por clasificar y de Otros documentos, los mueve al cliente y tipo correctos y propone clientes nuevos.</p>
      </section>
      <AiRunner autoOpen={params.get("start") === "1"} onFinished={onFinished} />
      <AiHistory reloadKey={reloadKey} />
    </AppShell>
  );
}
